import { EventStatus } from '../events/event.types';
import { EventCustomerRole } from '../events/customers/event-customer.types';
import { PagedFilter } from '../common/common.types';
import { CustomerNote } from './notes/customer-note.types';
import { CustomerLoyalty } from './loyalty/customer-loyalty.types';
import { CustomerReferral } from './referral/customer-referral.types';

import { Moment } from 'moment';

export class CustomerFilter extends PagedFilter {
  searchTerm?: string;
  statuses?: CustomerStatus[];
  types?: CustomerType[];
}

export enum CustomerStatus {
  Active = 1,
  Archived = 2
}

export enum CustomerType {
  Company = 1,
  Person = 2,
  Child = 3
}

export enum LoyaltyType {
  Free = 1,
  Paid = 2
}

export class CustomerSummary {
  customerId: number;
  status: CustomerStatus;
  type: CustomerType;
  name: string;
  phone: string;
  email: string;
  isRegistered: boolean;
}

export interface NewCustomer {
  type: CustomerType;
  name?: string;
  jobTitle?: string;
  email?: string;
  phone?: string;
  secondaryEmail?: string;
  secondaryPhone?: string;
  dateOfBirth?: Moment | string;
  loyalty?: CustomerLoyalty;
  referral?: CustomerReferral;
}

export interface UpdatedCustomer {
  status: CustomerStatus;
  type: CustomerType;
  name?: string;
  jobTitle?: string;
  phone?: string;
  email?: string;
  secondaryEmail?: string;
  secondaryPhone?: string;
  dateOfBirth?: string | Moment;
  loyalty?: CustomerLoyalty;
  referral?: CustomerReferral;
}

export class Customer {
  customerId: number;
  status: CustomerStatus;
  type: CustomerType;
  name?: string;
  jobTitle?: string;
  email?: string;
  phone?: string;
  secondaryPhone?: string;
  secondaryEmail?: string;
  dateOfBirth?: Moment | string;
  relationships: CustomerRelationship[];
  events: CustomerEvent[];
  notes: CustomerNote[];
  isRegistered: boolean;
  loyalty: CustomerLoyalty;
  referral: CustomerReferral;
}

export class CustomerRelationship {
  customerId: number;
  type: CustomerRelationshipType;
  name: string;
}

export enum CustomerRelationshipType {
  CompanyEmployee = 1,
  Employer = 2,
  Parent = 3,
  Child = 4
}

export class CustomerEvent {
  eventId: number;
  extendedEventId: string;
  legacyBookingId?: number;
  eventVertical?: string;
  eventType?: string;
  eventOccasion?: string;

  role: EventCustomerRole;
  name?: string;
  status: EventStatus;

  startsOn?: string | Moment;
  endsOn?: string | Moment;
  timezone?: string;

  feedbackScore?: number;
  feedbackComment?: string;
}
